<template>
  <vue-admin-tasks-base-task-card :card-status="cardStatus" :loading="taskData.isLoading" :error="taskData.error" ref="baseTaskCard">
    <template v-slot:header>
      <div class="d-flex">
        <div class="flex-grow-1">
          <span>{{taskData.title}}</span>
        </div>
        <div>
          <vue-admin-tasks-task-card-menu :taskData="taskData">
            <template v-slot:wrapper>
              <a class="link-dark"><i class="bi bi-three-dots-vertical"></i></a>
            </template>
          </vue-admin-tasks-task-card-menu>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div :class="`${step==0 ? '' : 'hidden'}`">
        <vue-admin-tasks-timer :time="taskData.duration" :task-data="taskData"></vue-admin-tasks-timer>
      </div>
      <div :class="`${step==1 ? '' : 'hidden'}`">
        <vue-admin-tasks-description-saved-task-time :initial-description="taskData.description"></vue-admin-tasks-description-saved-task-time>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <div class="flex-grow-1">
          <vue-admin-tasks-task-tags :taskData="taskData"></vue-admin-tasks-task-tags>
        </div>
        <div ml="0.5">
          <span class="link-dark" v-if="step==0" @click="changeStep(1)" :title="$t('descriptionLinkTitle')"><i class="bi bi-card-text"></i></span>
          <span class="link-dark" v-if="step==1" @click="changeStep(0)" :title="$t('timerLinkTitle')"><i class="bi bi-clock-history"></i></span>
        </div>
      </div>
    </template>
  </vue-admin-tasks-base-task-card>
</template>
<script>
  import { mapActions } from 'vuex';
  import { ERROR_TYPES } from './tasksConsts';

  export default{
    data: function(){
      return {
        step: 0,
        loading: false
      }
    },
    props:{
      taskData: {
        type: Object,
        default: () => {},
      }
    },
    computed: {
      cardStatus: function(){
        switch(this.taskData.timerState){
          case 0:
            return 'gray'
          case 1:
            return 'primary'
          case 2:
            return 'warning'
          case 3:
            return 'success'
        }
      },
      error: function(){
        return this.taskData.error;
      }
    },
    methods: {
      ...mapActions('taskStoreModule', ['deleteTask']),
      changeStep(step){
        this.step = step;
      },
      removeTask(){
        this.deleteTask({task_id: this.taskData.id })
      }
    },
    i18n: {
      messages: {
        "pt-BR": {
          descriptionLinkTitle: 'Descrição',
          timerLinkTitle: 'Relógio',
        },
        en: {
          descriptionLinkTitle: 'Description',
          timerLinkTitle: 'Clock',
        }
      }
    }
  }
</script>
